import type { CaseAttributeKind } from '@tms/shared';
import type { MessageKey } from '../../i18n';

/**
 * Layers and modules are the same screen twice, but they are not the same
 * words: one dictionary key per kind keeps both languages readable and keeps
 * the translation check able to see every message.
 */
export interface CaseAttributeMessages {
  title: MessageKey;
  hint: MessageKey;
  empty: MessageKey;
  none: MessageKey;
  new: MessageKey;
  newPlaceholder: MessageKey;
  create: MessageKey;
  editTitle: MessageKey;
  actionsFor: MessageKey;
  deleteTitle: MessageKey;
  deleteHint: MessageKey;
  notUsed: MessageKey;
  usage: MessageKey;
  created: MessageKey;
  updated: MessageKey;
  deleted: MessageKey;
  saveFailed: MessageKey;
  deleteFailed: MessageKey;
  /** The singular noun, as a field label or a column header uses it. */
  field: MessageKey;
}

export const CASE_ATTRIBUTE_MESSAGES: Record<CaseAttributeKind, CaseAttributeMessages> = {
  layer: {
    title: 'layers.title',
    hint: 'layers.hint',
    empty: 'layers.empty',
    none: 'layers.none',
    new: 'layers.new',
    newPlaceholder: 'layers.newPlaceholder',
    create: 'layers.create',
    editTitle: 'layers.editTitle',
    actionsFor: 'layers.actionsFor',
    deleteTitle: 'layers.deleteTitle',
    deleteHint: 'layers.deleteHint',
    notUsed: 'layers.notUsed',
    usage: 'layers.usage',
    created: 'layers.created',
    updated: 'layers.updated',
    deleted: 'layers.deleted',
    saveFailed: 'layers.saveFailed',
    deleteFailed: 'layers.deleteFailed',
    field: 'common.layer',
  },
  module: {
    title: 'modules.title',
    hint: 'modules.hint',
    empty: 'modules.empty',
    none: 'modules.none',
    new: 'modules.new',
    newPlaceholder: 'modules.newPlaceholder',
    create: 'modules.create',
    editTitle: 'modules.editTitle',
    actionsFor: 'modules.actionsFor',
    deleteTitle: 'modules.deleteTitle',
    deleteHint: 'modules.deleteHint',
    notUsed: 'modules.notUsed',
    usage: 'modules.usage',
    created: 'modules.created',
    updated: 'modules.updated',
    deleted: 'modules.deleted',
    saveFailed: 'modules.saveFailed',
    deleteFailed: 'modules.deleteFailed',
    field: 'common.module',
  },
};
